var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._t("default",null,{"json":_vm.json,"state":_vm.state,"response":_vm.response})],2)}
var staticRenderFns = []

export { render, staticRenderFns }